module.exports = __webpack_public_path__ + "img/collection.947b58b8.svg";